import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

// Optionally set base URL
// axios.defaults.baseURL = import.meta.env.VITE_API_URL || ''


// REQUEST INTERCEPTOR
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// RESPONSE INTERCEPTOR
axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      const authStore = useAuthStore()  // ✅ Move this here

      try {
        const refreshed = await authStore.refreshToken()

        if (refreshed) {
          originalRequest.headers.Authorization = `Bearer ${authStore.token}`
          return axios(originalRequest)
        } else {
          console.warn('[AXIOS] Token refresh failed. Redirecting to login.')
          authStore.logout()
          window.location.href = '/#/login-form'
        }
      } catch (refreshErr) {
        console.error('[AXIOS] Unexpected error during refresh:', refreshErr)
        authStore.logout()
        window.location.href = '/#/login-form'
      }
    }

    return Promise.reject(error)
  }
)